// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"Dropdown_dropdown__k6M6g","dropdownV2":"Dropdown_dropdownV2__ZLmHB"};